import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import module from 'app/modules/well-schematic-diagram/well-schematic-diagram.module';

@Component({
  selector: 'app-history-record-details',
  standalone: true,
  imports: module,
  templateUrl: './history-record-details.component.html',
  styleUrl: './history-record-details.component.scss'
})
export class HistoryRecordDetailsComponent {
  historyDetails: any[] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    let historyDetail = this.data.historyRecordDetail

    Object.keys(historyDetail).forEach(key => {
      if(['id','wellStringId','inputBy','inputDate'].includes(key)) return

      this.historyDetails.push({
        element: this.getElementName(key),
        status: historyDetail[key]
      });
    });
  }

  handleFormatDate(dateString: string, withTime) {
    return handleFormatDate(dateString, withTime)
  }

  getElementName(key) {
    let elementName = ''

    switch (key) {
      case 'crownValve':
        elementName = 'Crown Valve'
        break
      case 'wingValve':
        elementName = 'Wing Valve'
        break
      case 'killWingValve':
        elementName = 'Kill Wing Valve'
        break
      case 'surfaceSafetyValve':
        elementName = 'Surface Safety Valves'
        break
      case 'lowerMasterValve':
        elementName = 'Lower Safety Valves'
        break
      case 'conductorCasingValves':
        elementName = 'Conductor Casing Valves'
        break
      case 'surfaceCasingValves':
        elementName = 'Surface Casing Valves'
        break
      case 'intermediateCasingValves':
        elementName = 'Intermediate Casing Valves'
        break
      case 'productionCasingValves':
        elementName = 'Production Casing Valves'
        break
      case 'conductorCasing':
        elementName = 'Conductor Casing'
        break
      case 'surfaceCasing':
        elementName = 'Surface Casing'
        break
      case 'intermediateCasing':
        elementName = 'Intermediate Casing'
        break
      case 'productionCasingAbovePaker':
        elementName = 'Production Casing (Above Packec)'
        break
      case 'productionCasingBelowPaker':
        elementName = 'Production Casing (Below Packec)'
        break
      case 'casingHanger':
        elementName = 'Casing Hanger'
        break
      case 'tubingHanger':
        elementName = 'Tubing Hanger'
        break
      case 'cementConductrorCasing':
        elementName = 'Cement (Conductor Casing)'
        break
      case 'cementSurfaceCasing':
        elementName = 'Cement (Surface Casing)'
        break
      case 'cementIntermediateCasing':
        elementName = 'Cement (Intermediate Casing)'
        break
      case 'cementProductionCasing':
        elementName = 'Cement (Production Casing)'
        break
      case 'productionTubingAboveDHSV':
        elementName = 'Production Tubing (Above DHSV)'
        break
      case 'productionTubingBelowDHSV':
        elementName = 'Production Tubing (Below DHSV)'
        break
      case 'downholeSafetyValve':
        elementName = 'Downhole Safety Valve'
        break
      case 'dhsvControlLine':
        elementName = 'DHSV Control Line'
        break
      case 'safetyValveLandingNipple':
        elementName = 'Safety Valve Landing Nipple'
        break
      case 'svlnControlLine':
        elementName = 'SVLN Control Line'
        break
      case 'gasLiftMandrel':
        elementName = 'Gas Lift Mandrel'
        break
      case 'slidingSideDoor':
        elementName = 'Sliding Side Door'
        break
      case 'productionPacker':
        elementName = 'Production Pakcer'
        break
      case 'tubingPlug':
        elementName = 'Tubing Plug'
        break
      case 'bpvTwcv':
        elementName = 'BPV / TWCV'
        break
      case 'vrPlug':
        elementName = 'VR Plug'
        break
      case 'caprock':
        elementName = 'Caprock'
        break
      case 'voidArea':
        elementName = 'Void Area'
        break
      case 'inSituFormation':
        elementName = 'IN-SITU Formation'
        break
    }

    return elementName
  }

  getStatusClass(value: string | null | undefined) {
    switch (value) {
      case 'Good':
        return 'successBadge';
      case 'Fail':
        return 'failedBadge';
      case 'Degraded':
        return 'warningBadge';
      default:
        return '';
    }
  }
}